import { render, staticRenderFns } from "./ContentComment.vue?vue&type=template&id=78145df8&scoped=true&"
import script from "./ContentComment.vue?vue&type=script&lang=js&"
export * from "./ContentComment.vue?vue&type=script&lang=js&"
import style0 from "./ContentComment.vue?vue&type=style&index=0&id=78145df8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78145df8",
  null
  
)

export default component.exports